import React, { useState } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Backdrop, Button, Fade, Grid, Modal, Tooltip, Typography } from '@material-ui/core'
import { getPrimeiroNome } from 'utils/helpers'
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt'
import { useAuth } from 'hooks/useAuth'
import useRouter from 'utils/useRouter'
import constants from 'utils/constants'

const useStyles = makeStyles((theme) => ({
  root: {},
  dates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  startDateButton: {
    marginRight: theme.spacing(1),
  },
  endDateButton: {
    marginLeft: theme.spacing(1),
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1),
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  tituloEspelho: {
    fontSize: '16px',
  },
}))

export const Header = (props) => {
  const { className, handleChangeLayout, ...rest } = props
  const { currentUser } = useAuth()
  const classes = useStyles()
  const [openLayout, setOpenLayout] = useState(false)
  const router = useRouter()

  const closeLayout = () => {
    setOpenLayout(false)
  }

  const handleOpenLayout = () => {
    setOpenLayout(true)
  }

  const handleClickOpcaoLayout = (tipo) => {
    handleChangeLayout(tipo)
    setOpenLayout(false)
  }



  return (
    <div {...rest} className={clsx(classes.root, className)}>
      {/* <Typography component="h2" gutterBottom variant="overline">
        Home
      </Typography> */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography component="h1" gutterBottom variant="h3">
        Dashboard
        </Typography>
      </Grid>
    </div>
  )
}
